export const sizes = [
  {
    label: '10',
    value: 10
  },
  {
    label: '20',
    value: 20
  },
  {
    label: '30',
    value: 30
  }
]

export const units = [
  { label: 'GB', value: 'GB' },
  { label: 'TB', value: 'TB' }
]

export const months = [
  {
    label: '1_month',
    value: 1
  },
  {
    label: '2_months',
    value: 2
  },
  {
    label: '3_months',
    value: 3
  },
  {
    label: '4_months',
    value: 4
  },
  {
    label: '5_months',
    value: 5
  },
  {
    label: '6_months',
    value: 6
  },
  {
    label: '7_months',
    value: 7
  },
  {
    label: '8_months',
    value: 8
  },
  {
    label: '9_months',
    value: 9
  },
  {
    label: '10_months',
    value: 10
  },
  {
    label: '11_months',
    value: 11
  },
  {
    label: '12_months',
    value: 12
  }
]
